export default "__VITE_ASSET__6863e591__"